import { CONTAINER_TRACKING, SALES_ORDER, IMPORTS_CONTAINER_TRACKING, IMPORTS, EXPORTS,
  EXPORTS_CONTAINER_TRACKING,
  EXPORTS_SALES_ORDER, IMPORTS_SALES_ORDER, API } from 'src/utils/partsToShow/partsConstants';
export const map = {
  [CONTAINER_TRACKING]: {
    import: [IMPORTS_CONTAINER_TRACKING],
    export: [EXPORTS_CONTAINER_TRACKING],
  },
  [SALES_ORDER]: {
    import: [IMPORTS_SALES_ORDER],
    export: [EXPORTS_SALES_ORDER],
  },
  [IMPORTS]: {
    import: [IMPORTS],
  },
  [EXPORTS]: {
    export: [EXPORTS],
  },
  [API]: API,
};
